// JavaScript code for sn/menus/country-menu component
(($) => {

     "use strict";
     console.log("sn/menus/country-menu scripts loaded...");

     $('.sn-menus-country-menu .btn-country').on('click', function() {
        $('.sn-menus-country-menu').toggleClass('active');
     });
     
     $(document).on('click', function(e) {
        if ($(e.target).closest('.sn-menus-country-menu').length) return;
        $('.sn-menus-country-menu').removeClass('active');
     });

})(jQuery);